import { Button } from '@client/toolkit';

interface OnboardingActionsProps {
  onBack?: () => void;
  onNext?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  showBack?: boolean;
}

export function OnboardingActions({
  onBack,
  onNext,
  nextLabel = 'Neste steg →',
  nextDisabled = false,
  showBack = true,
}: OnboardingActionsProps) {
  return (
    <div className="flex items-center justify-between mt-10 pt-6 border-t border-border">
      {showBack && onBack ? (
        <Button color="primary-dark" size="md" onClick={onBack}>
          Tilbake
        </Button>
      ) : (
        <div />
      )}

      {onNext && (
        <Button color="primary" size="md" onClick={onNext} disabled={nextDisabled}>
          {nextLabel}
        </Button>
      )}
    </div>
  );
}
